import { EnvironmentProviders, Provider } from '@angular/core';
import { SortService } from "./services/sort.service";

export const sortProviders: Array<Provider | EnvironmentProviders> = [
  SortService
]
